import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAppBar,{staticClass:"white",attrs:{"app":""}},[_c(VToolbarTitle,{staticClass:"headline text-uppercase"},[_c('span',[_c('img',{staticClass:"site-logo",attrs:{"src":require("../../assets/logo.png")}})])]),_c(VSpacer),_c(VBtn,{attrs:{"text":"","href":_vm.dashboardUrl}},[_c('span',{staticClass:"mr-2",domProps:{"innerHTML":_vm._s(`< ${_vm.$t('global-terms.back-to-dashboard')}`)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }